export const calculateShowResult = (
  bankerLength: number,
  playerLength: number,
): number => {
  const sum = bankerLength + playerLength
  const dealDuration = 0.4
  const lastCardDelay = 1
  switch (sum) {
    case 4:
      return dealDuration * 4
    case 5:
      return dealDuration * 5 + lastCardDelay
    case 6:
      return dealDuration * 6 + lastCardDelay
    default:
      return dealDuration * 4
  }
}

export const calculateTimings = (
  name: string,
  length: number,
  bankerLength: number | undefined,
): number => {
  if (name === "banker") {
    return length === 2 ? 2.4 : 4.2
  } else {
    return length === 2 ? 2.8 : bankerLength === 3 ? 4.2 : 4.6
  }
}
